export const isInvalidAddressError = error => {
  return (
    error.code === 400 &&
    (error.message === 'Missing addressId/ pin code' ||
      error.message === 'Error fetching address' ||
      error.message === 'Invalid addressId')
  )
}
